webpackJsonp([10],{

/***/ 1918:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1943),
  /* template */
  __webpack_require__(1993),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1943:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_reboquista_services_reboquista__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_mask__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  nome: 'atendente-reboquista-form',
  directives: { mask: __WEBPACK_IMPORTED_MODULE_2_v_mask__["a" /* VueMaskDirective */] },
  props: {
    user: {
      required: true,
      type: Object
    },
    reboquistaId: {
      type: Number
    }
  },
  data: function data() {
    return {
      isLoading: false,
      isLoaded: false,
      cadastroError: null,
      atualizadoSucesso: null,
      extraModel: {
        validadeCnh: null
      },
      data: {
        id: null,
        nome: null,
        rg: null,
        cnh: null,
        validadeCnh: null,
        codigo: null,
        ativo: 1,
        sequencialGrv: 1,
        usuario: null,
        atendente: true
      },
      idReboquista: null,
      codigoReboquista: {
        numero: null,
        existe: null
      }
    };
  },

  computed: {},
  created: function created() {
    this.idReboquista = this.user.reboquista;
    this.data.usuario = this.user.id;
  },
  mounted: function mounted() {
    this.data.nome = this.user.pessoa.nome;
    this.start();
  },
  activated: function activated() {},
  destroyed: function destroyed() {},

  watch: {},
  methods: {
    start: function start() {
      var _this = this;

      if (this.idReboquista) {
        this.$loaderOverlay.open().message('Carregando');
        __WEBPACK_IMPORTED_MODULE_0__domain_reboquista_services_reboquista__["a" /* default */].find(this.idReboquista).then(function (response) {
          _this.isLoaded = true;
          _this.$loaderOverlay.hide();
          _this.data = response.data;
          if (_this.data.usuario) {
            _this.data.usuario = _this.data.usuario.id;
          }
          console.log(response);
        }).catch(function (response) {
          _this.$loaderOverlay.hide();
          console.log(response);
        });
      } else {
        this.isLoaded = true;
      }
    },
    submit: function submit() {
      var _this2 = this;

      this.cadastroError = null;
      this.atualizadoSucesso = false;
      this.$loaderOverlay.open().message('Processando...');
      this.$bar.start();
      window.setTimeout(function () {
        _this2.$loaderOverlay.message('Aguarde...');
      }, 1000);
      __WEBPACK_IMPORTED_MODULE_0__domain_reboquista_services_reboquista__["a" /* default */].cadastrar(this.data, this.idReboquista).then(function (response) {
        var callbackEnd = function callbackEnd() {
          _this2.$bar.finish();
          _this2.$loaderOverlay.hide();
          _this2.$emit('finishSubmit', response.data.id);
          if (_this2.idReboquista) {
            _this2.start();
            _this2.atualizadoSucesso = true;
            _this2.$el.querySelector('#sucessMsg').focus();
          } else {
            _this2.atualizadoSucesso = true;
          }
        };
        callbackEnd();
      }).catch(function (response) {
        _this2.$bar.finish();
        _this2.$loaderOverlay.hide();
        _this2.cadastroError = response.data.errors;
        _this2.$nextTick(function () {
          _this2.$refs.error.focus();
        });
        console.log(response);
      });
    },
    printError: function printError(err) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"])(err)) {
        return err[0];
      }
      return err;
    },

    checarNumeroGrv: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function () {
      var _this3 = this;

      var numero = this.data.codigo;
      if (numero === null || !numero.toString().trim().length) {
        this.codigoReboquista.existe = null;
        return;
      }
      this.codigoReboquista.existe = -1;
      __WEBPACK_IMPORTED_MODULE_0__domain_reboquista_services_reboquista__["a" /* default */].checarExistenciaCodigoReboquista(numero).then(function (response) {
        _this3.codigoReboquista.existe = response.data.existe;
      }).catch(function (error) {
        console.log(error);
        if (error.status === 404) {
          _this3.codigoReboquista.existe = false;
        } else {
          _this3.codigoReboquista.existe = null;
          alert('Ocorreu um erro ao checar a GRV');
        }
      });
    }, 300),
    sugerirCodigoReboquista: function sugerirCodigoReboquista() {
      var _this4 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__domain_reboquista_services_reboquista__["b" /* sugerirCodigoReboquista */])().then(function (response) {
        var codigo = response.data.codigo;

        _this4.data.codigo = String(codigo).padStart(3, '0');
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ 1993:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Cadastro de Código/Sequencial")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$route.params.id && 'Atualizado' || 'Cadastrado') + " com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Código")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.codigo),
      expression: "data.codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.codigo)
    },
    on: {
      "keyup": _vm.checarNumeroGrv,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "codigo", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.codigoReboquista.existe === true) ? _c('span', {
    staticClass: "text-danger text-center"
  }, [_c('i', {
    staticClass: "fa fa-times text-danger m-l-sm"
  }), _vm._v(" Código já cadastrado para outro reboquista\n                ")]) : _vm._e(), _vm._v(" "), (_vm.codigoReboquista.existe === false) ? _c('span', {
    staticClass: "text-success text-center"
  }, [_c('i', {
    staticClass: "fa fa-check text-success m-l-sm"
  }), _vm._v(" Código disponível\n                ")]) : _vm._e(), _vm._v(" "), (_vm.codigoReboquista.existe === -1) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin m-l-sm"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    on: {
      "click": _vm.sugerirCodigoReboquista
    }
  }, [_vm._v("Sugerir código")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Sequencial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.sequencialGrv),
      expression: "data.sequencialGrv"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.sequencialGrv)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "sequencialGrv", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.ativo),
      expression: "data.ativo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.ativo) ? _vm._i(_vm.data.ativo, null) > -1 : (_vm.data.ativo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.ativo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "ativo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "ativo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "ativo", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    attrs: {
      "disabled": _vm.codigoReboquista.existe === true || _vm.codigoReboquista.existe === -1
    },
    on: {
      "click": _vm.submit
    }
  }, [(!_vm.data.id) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()])], 1)])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.881f1423708317436fc5.js